<template>
    <div>
        <!-- Sidebar that display when User in Move Mode  -->
        <sidebar-menu
                :menu="menu"
                @collapse="onCollapse"
                :collapsed="isSideBarExpanded"
                @item-click="onItemClick"
        />
    </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';

export default {
  name: 'SideBarInTimeShiftMode',
  computed: {
    isSideBarExpanded() {
      return this.$store.getters.isSidebarExpanded;
    },
  },
  methods: {
    onCollapse(collapsed) {
      this.$store.dispatch('expandSidebar', collapsed);
    },
    onItemClick(event, item) {
      switch (item.id) {
        case 'timeshiftDisable':
          this.disableTimeShift();
          break;
        default:
          break;
      }
    },

    /*
        ======= ACTIONS =======
      */

    /**
       * Disables the move mode which allows users to move chapters & entries
       */
    disableTimeShift() {
      this.$store.commit('setChapterEntryMode', 'default');
    },
  },
  data() {
    return {
      menu: [
        {
          title: this.$t('UI_INSTANCE_FAB_MENU_TIMESHIFT_DISABLE'),
          icon: 'fa fa-times',
          id: 'timeshiftDisable',
        },
      ],

    };
  },
};
</script>

<style scoped>

</style>
